import App from './App.svelte';
const target = document.getElementById('beesecure-form');
if (!target) {
    throw new Error("Target element 'beesecure-form' not found.");
}
// Create the Svelte app instance
const app = new App({
    target: target,
});
// Export the app instance
export default app;
